module.exports = __webpack_public_path__ + "img/AMWETCarousel_calf.a314275e.jpg";